import { createSlice } from '@reduxjs/toolkit'

type MemberState = {
  customerNumber: string
  userSeq: string
  userName: string
}

const initialState: MemberState = {
  customerNumber: '',
  userSeq: '',
  userName: '',
}

const memberSlice = createSlice({
  name: 'member',
  initialState,
  reducers: {
    setMember: (state, { payload }) => {
      state.customerNumber = payload.customerNumber
      state.userSeq = payload.userSeq
      state.userName = payload.userName
    },
  },
})

export const { setMember } = memberSlice.actions
export default memberSlice.reducer
